import axios from "axios";

const upload = (
  file,
  url,
  accountingSoftwareType,
  customFieldsMapping,
  onUploadProgress
) => {
  // for (const [key, value] of Object.entries(customFieldsMapping)) {
  //   if (typeof value === "string" && value.indexOf("{") > -1) {
  //     let splitRow = value.split(" ");

  //     let fields = new Array();
  //     let op = "+";

  //     for (let index = 0; index < splitRow.length; index++) {
  //       var part = splitRow[index].substring(
  //         splitRow[index].lastIndexOf("{") + 1,
  //         splitRow[index].lastIndexOf("}")
  //       );

  //       if (part == "+") op = part;
  //       else fields.push(part);
  //     }
  //   }
  // }

  let formData = new FormData();
  formData.append("files", file);
  formData.append("accounting_software_type", accountingSoftwareType);
  formData.append("custom_mapping", JSON.stringify(customFieldsMapping));

  return axios
    .post(process.env.REACT_APP_API_BASE_URL + url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch(function() {
      console.log("FAILURE!!");
    });
};

export default {
  upload,
};
